import { Link } from "react-router-dom";
import { Button } from "../../component/ui/button";
import { Input } from "../../component/ui/input";
import { Label } from "../../component/ui/label";
import {
  composeValidators,
  email,
  renderField,
  required,
  validatePassword,
} from "../../helpers/form-validations";
import { Field, Form } from "react-final-form";
import { EyeNoneIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import OTPComponent from "../../component/login/otpComponent";
import { login } from "../../utils/util";
import GetEmail from "../../component/login/getEmail";
import { useDispatch } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";

// Fix for accessibility issues. Issue # VI26-97
export const description =
  "A login page with two columns. The first column has the login form with email and password. There's a Forgot your password link and a link to sign up if you do not have an account. The second column has a cover image.";

export function Login() {
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  //   const onSubmit = (values) => {
  //     console.log(values); // Handle form submission here
  //   };
  const [isResetPassword, setIsResetPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    // Save the isOTP state to localStorage whenever it changes

    localStorage.setItem("isOTPPage", isVerified);
  }, [isVerified]);

  const onSubmit = async (formData) => {
    dispatch(loaderSet(true))
    const loginPayload = {
      email: formData.email,
      password: formData.password,
    };

    console.log(
      "Email : ",
      loginPayload.email,
      "password : ",
      loginPayload.password
    );

    try {
      const response = await login(loginPayload);

      if (formData.email !== "") {
        localStorage.setItem("email", formData.email);
      }

      if (response && response?.code === 200) {

        setIsVerified(true);
        dispatch(alertSuccess("OTP successfully sent to your Email"))
        localStorage.setItem("email", formData.email);
        localStorage.setItem("password", formData.password);
        dispatch(loaderSet(false))
      }
      else {
        dispatch(alertDanger(response?.message))
        dispatch(loaderSet(false))
      }
    } catch (error) {
      // Log error for debugging
      console.error("Error during login:", error);
      dispatch(alertDanger(error.message))
      dispatch(loaderSet(false))
      //   setFormErrors({ general: 'An error occurred during login. Please try again.' });
    }
  };

  const backToLoginPageFromOTPPage = () => {
    setIsVerified(false);
    setIsResetPassword(false);
    localStorage.setItem("email", null);
  };

  return (
    <>
      <div className="w-full grid h-[100vh]  lg:grid-cols-2 md:h-[100vh]  lg:h-[100vh] xl:h-[100vh] 2xl:h-[100vh]">
        {/* Left side image */}
        <div className="hidden bg-muted lg:block">
          {/* <Image src="/placeholder.svg" alt="Image" width="1920" height="1080" className="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale" /> */}
        </div>

        {/* Right side login */}
        {!isVerified && !isResetPassword ? (
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                {/* Accessiblity issue fixed - issues VII26-101 */}
                <main className="flex  justify-center py-16 h-[100%] text-black " aria-labelledby="login-heading">
                  <div className="mx-auto flex flex-col w-full gap-6">
                    <div className=" flex justify-center items-center w-full">
                      {/* Accessiblity issue fixed - issues VII26-105 */}
                      <Link to="/" aria-label="Vasuki India Home" className="rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]">
                        <img src="/vasuki-logo.svg" className="w-56" alt="Vasuki India logo" />
                      </Link>
                    </div>
                    <div className=" grid gap-2 pl-10 pr-10">
                      <h1 id="login-heading" className="text-start text-[#0D215C] font-bold text-[30px] py-2">
                        LOGIN
                      </h1>
                      <div className="grid gap-2">
                        <Label
                          className="text-start text-[#0D215C] font-bold text-lg"
                          htmlFor="email"
                        >
                          Email
                        </Label>
                        {/* Accessiblity issue fixed - issues VII26-96 */}
                        <Field
                          id="email"
                          type="email"
                          name="email"
                          placeholder=" abc1234@gmail.com"
                          autoComplete="username"
                          aria-label="Email"
                          validate={composeValidators(required, email)}
                          component={renderField} // Correct usage of renderField
                          className="bg-white h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                        />
                      </div>
                      <div className=" relative grid gap-2">
                        <div className="flex items-center">
                          <Label
                            className="text-start text-[#0D215C] font-bold text-lg"
                            htmlFor="password"
                          >
                            Password
                          </Label>
                        </div>
                        {/* Accessiblity issue fixed - issues VII26-96 */}
                        <Field
                          id="password"
                          type={showPassword ? "text" : "password"}
                          name="password"
                          placeholder="*************"
                          autoComplete="current-password"
                          aria-label="Password"
                          validate={composeValidators(required)} // Use the updated validatePassword
                          component={renderField} // Reuse the same renderField component
                          className="bg-white h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                        />
                        {/* Accessiblity issue fixed - issues VII26-99 */}
                        <button
                          type="button"
                          className="absolute h-15 top-11 -right-1 flex items-center px-4 cursor-pointer"
                          onClick={togglePasswordVisibility}
                          aria-label={showPassword ? "Hide password" : "Show password"}
                          aria-pressed={showPassword}
                          aria-controls="password"
                        >
                          {showPassword ? (
                            <EyeNoneIcon className="h-5 w-5 text-black" />
                          ) : (
                            <EyeOpenIcon className="h-5 w-5 text-black" />
                          )}
                        </button>
                      </div>
                      <div className="flex justify-between py-2  w-full">
                        {/* Accessiblity issue fixed - issues VII26-98 */}
                        <Button type="submit" className="w-[40%] bg-[#0D215C]" aria-label="Generate one-time password for login">
                          Generate OTP
                        </Button>
                        {/* Accessiblity issue fixed - issues VII26-103, VII26-108 */}
                        <button
                          type="button"
                          onClick={() => setIsResetPassword(true)}
                          // Accessiblity issue fixed - issues VII26-100
                          className="ml-auto inline-flex min-h-11 items-center px-2 text-[#0A1D4D] text-md font-semibold underline cursor-pointer rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]"
                        >
                          Forgot your password?
                        </button>
                      </div>
                    </div>
                  </div>
                </main>
              </form>
            )}
          />
        ) : isResetPassword ? (
          <GetEmail onBack={backToLoginPageFromOTPPage} />
        ) : (
          <OTPComponent onBack={backToLoginPageFromOTPPage} />
        )}
      </div>
    </>
  );
}

export default Login;